import type { FindAJobDropdownData } from '#/components/FindAJobDropdown/types/FindAJobDropdownData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/routing/helpers/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/routing/helpers/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/routing/helpers/searchGetOrgsRoutePath';

export const findAJobDropdownDataEs: FindAJobDropdownData = {
  search: {
    title: 'Encuentra',
    items: [
      {
        type: 'job',
        title: 'Empleos',
        href: searchGetJobsRoutePath({ locale: I18nLocale.ES }),
      },
      {
        type: 'internship',
        title: 'Pasantías',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.ES }),
      },
      {
        type: 'org',
        title: 'Organizaciones',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.ES }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'career-advice',
        title: 'Desarrollo de carrera',
        description:
          'Herramientas y consejos útiles para construir una carrera profesional con impacto.',
        href: '/es/accion?categories=empleocambiamundo&pq=',
      },
    ],
  },
};
